import { gql } from "@apollo/client";

export const GET_APP_VERSION_LIST = gql`
  query GetAppVersionList($type: String, $page: Int!, $size: Int!) {
    getAppVersionList(type: $type, page: $page, size: $size) {
      content {
        id
        versionCode
        versionName
        url
        isForceUpdate
        forceUpdateVersionCode
        enabledAt
        description
        type
        createdAt
        updatedAt
      }
      totalElements
    }
  }
`;

export interface AppVersionItem {
  id: string;
  versionCode: number;
  versionName: string;
  url: string;
  isForceUpdate: boolean;
  forceUpdateVersionCode: number | null;
  enabledAt: string | null;
  description: string | null;
  type: string;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface GetAppVersionListResponse {
  getAppVersionList: {
    content: AppVersionItem[];
    totalElements: number;
  };
}
